export const projectFive = {
  id: 'Project',
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Project 5',
  headline: 'ShipCaptain',
  description:
    "As Lead Developer, architected and built ShipCaptain's full-stack shipping platform, developing the WMS (Warehouse Management System), OMS (Order Management System), Carrier Connect, and the online shipping platform. The platform enables businesses to rate-shop and compare shipping rates across enterprise carrier accounts including USPS, UPS, FedEx, DHL, and UniUni, helping users secure the most cost-effective shipping options. Built multi-carrier batch label creation, real-time inventory synchronization, automated order routing, and e-commerce integrations with Shopify, TikTok Shop, and Amazon.",
  buttonLabel: 'Visit Site',
  buttonLabel2: "Learn More",
  imgStart: true,
  img: require('../../images/Shipcaptain.mp4'),
  alt: 'ShipCaptain',
  dark: true,
  primary: true,
  darkText: false
};
